import { render } from "./Prompt.vue?vue&type=template&id=47ec3f2b&scoped=true&ts=true"
import script from "./Prompt.vue?vue&type=script&lang=ts"
export * from "./Prompt.vue?vue&type=script&lang=ts"

import "./Prompt.vue?vue&type=style&index=0&id=47ec3f2b&lang=scss&scoped=true"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ec3f2b"]])

export default __exports__